export interface ErrorType {
  getMessage(): string;
}

export class UnauthorizedError implements ErrorType {
  getMessage(): string {
    return 'Login failed: Unauthorized. Please check your credentials.';
  }
}

export class NotFoundError implements ErrorType {
  getMessage(): string {
    return 'Resource not found.';
  }
}

export class ServerError implements ErrorType {
  getMessage(): string {
    return 'Server error: Please try again later.';
  }
}

export class GenericError implements ErrorType {
  getMessage(): string {
    return 'An unexpected error occurred.';
  }
}
